export default "__VITE_ASSET__BdjECJ46__"